<template>
  <div class="page-container main">
      <el-form size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="form">
        <el-form-item label="省/市" prop="provinceCity">
          <el-cascader :props="defaultProps" :options="options" v-model="ruleForm.provinceCity" @change="handleHospital" clearable :style="{width: '216px'}"></el-cascader>
        </el-form-item>
        <el-form-item label="医院" prop="localId">
          <el-select v-model="ruleForm.localId" filterable placeholder="请选择医院" :style="{width: '216px'}">
            <el-option
              v-for="item in hospitalList"
              :key="item.localId"
              :label="item.name"
              :value="item.localId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科室" prop="departmentName">
          <el-input v-model="ruleForm.departmentName"></el-input>
        </el-form-item>
        <el-form-item label="科室缩写" prop="orderAbbr">
          <el-input v-model="ruleForm.orderAbbr"></el-input>
        </el-form-item>
        <el-form-item label="科室类型" prop="departmentType">
          <el-select v-model="ruleForm.departmentType" placeholder="请选择">
            <el-option
              v-for="item in depTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科室负责人姓名" prop="docName">
          <el-input v-model="ruleForm.docName"></el-input>
        </el-form-item>
        <el-form-item label="科室负责人电话" prop="mobile">
          <el-input v-model.number="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="ruleForm.note"></el-input>
        </el-form-item>
        <el-form size="small" ref="payForm" :inline="true" :model="ruleForm" :style="{width: 1088+'px'}">
          <el-divider content-position="left" class="dep-divider">收费项目</el-divider>
          <div
            v-for="(payItem, index) in ruleForm.payItems"
            :key="payItem.key"
          >
            <el-form-item label="名称" label-width="100px" :prop="'payItems.' + index + '.name'" :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
              <el-input v-model="payItem.name" :style="{width: 160+'px'}"></el-input>
            </el-form-item>
            <el-form-item label="金额" :prop="'payItems.' + index + '.price'" :rules="{required: true, message: '金额不能为空', trigger: 'blur'}">
              <el-input-number v-model="payItem.price" :precision="2" :step="0.1" :min="0" :controls=false :style="{width: 108+'px'}"></el-input-number>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="payItem.desc" :style="{width: 496+'px'}"></el-input>
            </el-form-item>
            <el-button size="small" @click.prevent="removePayItem(payItem)" v-if="ruleForm.payItems.length > 1">移除</el-button>
            <el-divider class="dep-divider dep-inner-divider"></el-divider>
          </div>
          <el-form-item label=" " label-width="100px">
            <el-button icon="el-icon-plus" size="mini" type="primary" @click="addPayItem">添加收费项目</el-button>
          </el-form-item>
          <el-divider class="dep-divider"></el-divider>
        </el-form>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">添加</el-button>
          <el-button @click="handleCancle">取消</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>
<script>
import { task as taskApi } from '@/api';
import { areas } from '@/utils/areas';

export default {
  name: 'AgentAccountAdd',
  data() {
    const validateMobile = (rule, value, callback) => {
      if (String(value).length !== 11) {
        callback(new Error('请输入正确的电话号码！'));
        return;
      }
      callback();
    };
    return {
      defaultProps: {
        value: 'code',
        label: 'name'
      },
      options: areas,
      ruleForm: {
        accountType: 'department',
        provinceCity: [],
        departmentName: undefined,
        docName: undefined,
        localId: undefined,
        mobile: undefined,
        email: undefined,
        note: undefined,
        orderAbbr: undefined,
        departmentType: undefined,
        payItems: [
          {
            key: 0,
            name: undefined,
            price: undefined,
            desc: undefined
          },
        ]
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        departmentName: [
          { required: true, message: '请输入科室', trigger: 'blur' },
        ],
        accountType: [
          { required: true, message: '请选择账号类型', trigger: 'change' },
        ],
        docName: [
          { required: true, message: '请输入医生姓名', trigger: 'blur' },
        ],
        orderAbbr: [
          { required: true, message: '请输入科室缩写', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              let patt = /^[a-zA-Z]{2}$/;
              if (!patt.test(value)) {
                callback(new Error('限定2个字母'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        departmentType: [
          { required: true, message: '必选项', trigger: 'blur' },
        ],
        localId: [
          { required: true, message: '请选择医院', trigger: 'change' }
        ],
        mobile: [
          { required: true, message: '请选输入电话', trigger: 'blur' },
          { type: 'number', message: '电话必须为数字' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        email: [
          { message: '请输入电子邮件', trigger: 'blur' }
        ],
        note: [
          { message: '请输入备注', trigger: 'blur' }
        ],
      },
      provinceCity: [],

      hospitalList: [],

      payFormValid: false,

      depTypeList: [
        {id: 0, name: '肝胆外科'},
        {id: 1, name: '胸外科'},
        {id: 2, name: '泌尿外科'},
        {id: 3, name: '妇科'},
        {id: 4, name: '耳鼻喉科'},
        {id: 5, name: '头颈外科'},
        {id: 6, name: '胃肠外科'},
        {id: 7, name: '颅脑科'},
        {id: 9, name: '默认'},
      ]
    };
  },
  methods: {
    addPayItem() {
      this.ruleForm.payItems.push({
        name: undefined,
        price: undefined,
        desc: undefined,
        key: Date.now()
      });
    },
    removePayItem(payItem) {
      let index = this.ruleForm.payItems.indexOf(payItem);
      if (index !== -1) {
        this.ruleForm.payItems.splice(index, 1);
      }
    },
    handleHospital(value) {
      if (value) {
        this.provinceCity = value;
      }
      if (!value && !this.provinceCity.length) return;
      taskApi.hospitalListName({
        pageNo: 1,
        pageSize: 1000,
        provinceId: this.provinceCity[0],
        cityId: this.provinceCity[1]
      })
        .then(res => {
          if (res.code === 10000) {
            const { data } = res.data;
            this.hospitalList = data;
            if (value) this.ruleForm.localId = '';
          }
        });
    },
    onCreated() {
      // this.loadHospital();
    },
    handleCancle() {
      this.resetForm('ruleForm');
      this.visible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs['payForm'].validate(valid => {
        this.payFormValid = valid;
        return valid;
      });
      this.$refs[formName].validate(valid => {
        if (this.payFormValid && valid) {
          const params = {
            docName: this.ruleForm.docName,
            item: this.ruleForm.payItems.map(item => {
              return { name: item.name, price: item.price, desc: item.desc };
            }),
            localId: this.ruleForm.localId,
            mobile: this.ruleForm.mobile,
            name: this.ruleForm.departmentName,
            orderAbbr: this.ruleForm.orderAbbr,
            type: this.ruleForm.departmentType,
            email: this.ruleForm.email,
            note: this.ruleForm.note
          };
          taskApi.departmentAdd(params).then(res => {
            if (res.code === 10000) {
              this.$message.success('添加成功!');
              this.resetForm('ruleForm');
              this.resetForm('payForm');
            }
          });
          this.payFormValid = false;
        }
      });
    },
  },
  created() {
    this.onCreated();
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  }
};
</script>
<style scoped>
.page-container {
  background-color: #212731;
}
.ruleForm {
  width: 500px;
}
.dep-divider {
  background-color: #121820;
}
.dep-inner-divider {
  margin: 0px 0px 22px 60px;
  width: 1016px;
}
.dep-divider .el-divider__text {
  background-color: #222933;
  color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/view/AgentAccountAdd/index.vue